module.exports = __webpack_public_path__ + "img/file.675e88dd.jpg";